<template>
  <section class="contacts-feedback">
    <Toolbar title-tag="h2">
      <template #title>Связь с нами</template>
    </Toolbar>

    <ContentBlock>
      <div class="contacts-feedback__content">
        <form class="contacts-feedback__form" @submit.prevent="submit">
          <div class="row">
            <div class="col-12 col-md-6">
              <AppControlText
                theme="third"
                class="contacts-feedback__field"
                label="Имя"
                placeholder="Ваше имя"
                :error="getErrorMessage('name')"
                v-model="$v.form.name.$model"
                :invalid="isInvalid('name')"
                @input="formErrors.name = ''"
              />
            </div>
            <div class="col-12 col-md-6">
              <AppControlText
                theme="third"
                class="contacts-feedback__field"
                label="E-Mail"
                placeholder="Ваш E-Mail"
                :error="getErrorMessage('email')"
                v-model="$v.form.email.$model"
                :invalid="isInvalid('email')"
                @input="formErrors.email = ''"
              />
            </div>
            <div class="col-12">
              <AppControlText
                theme="third"
                class="contacts-feedback__field"
                label="Тема"
                placeholder="Тема обращения"
                :error="getErrorMessage('subject')"
                v-model="$v.form.subject.$model"
                :invalid="isInvalid('subject')"
                @input="formErrors.subject = ''"
              />
            </div>
            <div class="col-12">
              <AppControl
                theme="third"
                class="contacts-feedback__field"
                label="Ваше обращение"
                :error="getErrorMessage('body')"
              >
                <AppInput
                  placeholder="Ваше обращение"
                  type="textarea"
                  theme="third"
                  :invalid="isInvalid('body')"
                  v-model="$v.form.body.$model"
                  @input="formErrors.body = ''"
                  class="contacts-feedback__textarea"
                  size="large"
                  :max-length="400"
                />
              </AppControl>
            </div>
          </div>
          <AppBtn
            class="contacts-feedback__submit"
            gradient="right"
            :loading="loading"
            type="submit"
            >Отправить</AppBtn
          >
        </form>
      </div>
    </ContentBlock>
  </section>
</template>

<script>
import Toolbar from "@/components/ui/toolbar/Toolbar";
import AppControlText from "@/components/ui/control/AppControlText.vue";
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import service from "@/services/contacts";
import { required, email } from "vuelidate/lib/validators";
import { showAlert, requestErrorAlert } from "@/core/common/";

const defaultForm = () => ({
  name: "",
  subject: "",
  email: "",
  body: ""
});

export default {
  name: "ContactUs",

  components: {
    Toolbar,
    AppControl,
    AppControlText
  },

  validations: {
    form: {
      name: { required },
      subject: { required },
      email: { required, email },
      body: { required }
    }
  },

  data: () => ({
    form: defaultForm(),
    formErrors: {},
    loading: false
  }),

  methods: {
    getErrorMessage(field) {
      return (
        this.formErrors[field] || getValidationMessage(this.$v.form[field])
      );
    },
    isInvalid(field) {
      return !!this.formErrors[field] || this.$v.form[field].$error;
    },
    async submit() {
      if (this.loading) return;

      this.formErrors = {};
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.loading = true;

      try {
        const { success, message } = await service.sendFeedback(this.form);

        message ? showAlert(message) : requestErrorAlert();

        if (success) {
          this.$v.$reset();
          this.form = defaultForm();
        }
      } catch {
        requestErrorAlert();
      }

      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
$w-xs: 410px;

.contacts-feedback {
  &__content {
    padding: 35px 25px 15px;
  }

  &__form {
    width: 100%;
    max-width: 570px;
    margin: 0 auto;
  }

  &__textarea {
    height: 200px;
    width: 100%;
    padding-top: 15px;
  }

  &__input {
    border-radius: 4px;
  }

  &__submit {
    height: 50px;
    font-size: 18px;
    display: flex;
    width: 250px;
    max-width: 100%;
    margin: 0 auto;
    text-transform: uppercase;
    margin-top: 40px;
  }

  @include breakpoint("sm-and-down") {
    &__content {
      padding: 0;
    }
  }
}
</style>
